/**
 * Erro de REDE = a requisição saiu e nenhuma resposta voltou (Wi-Fi trocou,
 * VPN piscou, conexão resetada). É diferente de erro do servidor (4xx/5xx),
 * que tem resposta e mensagem própria.
 *
 * Um único lugar decide a mensagem e o id do toast: com o mesmo `id`, o
 * sonner substitui o aviso anterior em vez de empilhar — uma queda de rede
 * vira UM aviso, não um por requisição que estava em voo.
 */
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

export const NETWORK_ERROR_MESSAGE =
  'Sua conexão falhou, por favor aguarde 1 minuto e tente acessar novamente.';

export const NETWORK_ERROR_TOAST_ID = 'network-error';

export const isNetworkError = (error: unknown): error is AxiosError => {
  const candidate = error as Partial<AxiosError> | null;
  return Boolean(candidate && candidate.isAxiosError && !candidate.response && candidate.request);
};

export const notifyNetworkError = (): void => {
  toast.error(NETWORK_ERROR_MESSAGE, { id: NETWORK_ERROR_TOAST_ID });
};
